import { render, staticRenderFns } from "./MenuSingle.vue?vue&type=template&id=4edca44c&scoped=true&"
import script from "./MenuSingle.vue?vue&type=script&lang=js&"
export * from "./MenuSingle.vue?vue&type=script&lang=js&"
import style0 from "./MenuSingle.vue?vue&type=style&index=0&id=4edca44c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edca44c",
  null
  
)

export default component.exports